import { render, staticRenderFns } from "./EmployeeCard.vue?vue&type=template&id=35740102&scoped=true"
import script from "./EmployeeCard.vue?vue&type=script&lang=js"
export * from "./EmployeeCard.vue?vue&type=script&lang=js"
import style0 from "./EmployeeCard.vue?vue&type=style&index=0&id=35740102&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35740102",
  null
  
)

export default component.exports